import { Button } from "antd";
import { AddFormStructureScenarioForm } from "components/Forms/AddFormStructureScenarioForm/AddFormStructureScenarioForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";

interface AddFormStructureScenarioDrawerProps {
    onSubmit: () => void;
}

export const AddFormStructureScenarioDrawer: FC<AddFormStructureScenarioDrawerProps> = ({ onSubmit }) => {
    const { t } = usePaldockTranslation("drawers.add-scenario");
    const { t: tC } = usePaldockTranslation("common");
    const id = DrawerId.AddFormStructureScenario;
    const drawerUtils = useDrawer();

    const handleSubmit = () => {
        onSubmit?.();
        drawerUtils.hide(id);
    };

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} />}
            extraButtons={
                <Button htmlType={"submit"} size={"large"} type="primary" form={FormId.AddFormStructureScenarioForm}>
                    {tC("save")}
                </Button>
            }
        >
            <div className={"w-100"}>
                <AddFormStructureScenarioForm onSubmit={handleSubmit} />
            </div>
        </Drawer>
    );
};
